import { getPath } from '@/router/common'

const baseUrl = {
  title: '模板',
  path: 'demo'
}
export default [
  {
    path: getPath('index', baseUrl),
    name: 'demo_index',
    component: () =>
      import(
        /* webpackChunkName: "demo_index" */ '@/views/demo/index/index.vue'
      ),
    meta: {
      title: '模板'
    }
  }
]
